import $axiosProtected from '../../../../common/utils/axiosUtils';

// Get Facility stock
export const getFacilityStock = async ({
    facilityCode,
    page,
    limit,
    filterOption,
    productName,
    genericName,
    productCode = '',
}: {
    facilityCode: string;
    page: number;
    limit: number;
    filterOption?: number;
    genericName?: string;
    productName?: string;
    productCode?: string;
}) => {
    return await $axiosProtected().get(
        `/inventory/stock/get/batch/web?page=${page}&limit=${limit}&facilityCode=${facilityCode}&filterOption=${filterOption}&genericName=${genericName}&productName=${productName}&productCode=${productCode}`
    );
};

// Get Facility stock by barcode exact search
export const getFacilityStockByBarcode = async ({
    facilityCode,
    productCode,
}: {
    facilityCode: string;
    productCode: string;
}) => {
    return await $axiosProtected().get(
        `/inventory/stock/get/batch/web/barcode/exact-search?facilityCode=${facilityCode}&productCode=${productCode}`
    );
};
